export const MASTER_CONFIG_OPTIONS = {
    API_URL : "https://wi8zkeven2.execute-api.us-east-1.amazonaws.com/prod/feedback",
} 
